import React from 'react'
import { useTheme } from '../../styles/useTheme'
import { Box } from '../Box'
import { Typography } from '../Typography'
import { Rating } from '../Rating'

interface ReviewProps {
  fullName: string
  avatar: React.ReactNode
  rating: number
  ratingLabel: string
  date: string
  content: string | React.ReactNode
  action?: React.ReactNode
  borderPrimaryColor?: boolean
}

function Review({
  fullName,
  avatar,
  rating,
  ratingLabel,
  date,
  content,
  action,
  borderPrimaryColor = false
}: ReviewProps) {
  const theme = useTheme()
  return (
    <Box
      p="16px"
      border={`1px solid ${borderPrimaryColor ? theme.palette.primary.main : theme.palette.neutral[200]}`}
      borderRadius="8px"
    >
      <Box
        display="flex"
        pb="16px"
        justifyContent="space-between"
        borderBottom={`1px solid ${theme.palette.neutral[200]}`}
      >
        <Box display="flex">
          <Box position="relative" width="48px" height="48px">
            {avatar}
          </Box>
          <Box ml="16px" alignSelf="center">
            <Typography fontSize="16px" lineHeight="24px">
              {fullName}
            </Typography>
            <Typography fontSize="12px" lineHeight="16px" color={theme.palette.neutral.main}>
              {date}
            </Typography>
          </Box>
        </Box>
        {action && <Box alignSelf="center">{action}</Box>}
      </Box>
      <Box pt="12px">
        <Box display="flex" alignItems="center">
          <Rating value={rating} readOnly />
          <Typography
            fontSize="14px"
            sx={{
              paddingTop: '2px',
              marginLeft: '8px'
            }}
          >
            {ratingLabel}
          </Typography>
        </Box>
        <Box mt="10px">
          <Typography sx={{ wordWrap: 'break-word' }} fontSize="14px" lineHeight="20px">
            {content}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

export { Review, type ReviewProps }
